import { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';

export function LoadingScreen() {
  // Показываем экран загрузки максимум 3 секунды, потом показываем ошибку
  const [showError, setShowError] = useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowError(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);
  
  if (showError) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white p-4">
        <div className="flex flex-col items-center gap-4 text-center">
          <p className="text-gray-800 text-lg font-semibold">Ошибка загрузки</p>
          <p className="text-gray-600 text-sm">Попробуйте перезагрузить приложение</p>
          <button 
            onClick={() => window.location.reload()} 
            className="px-4 py-2 bg-blue-500 text-white rounded-lg"
          >
            Перезагрузить
          </button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-tg-bg">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-10 h-10 text-tg-button animate-spin" />
        <p className="text-tg-hint text-sm">Загрузка...</p>
      </div>
    </div>
  );
}

export function LoadingSpinner({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
  };

  return <Loader2 className={`${sizeClasses[size]} text-tg-button animate-spin`} />;
}







































